import { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import api from "../lib/api";
import { Logo } from "../components/Logo";
import { useAuth } from "../context/AuthContext";

export default function PaymentSuccess() {
  const navigate = useNavigate();
  const { checkAuth } = useAuth();
  const [status, setStatus] = useState("checking");

  const poll = useCallback(async (sessionId, attempt) => {
    if (attempt > 8) { setStatus("timeout"); return; }
    try {
      const res = await api.get(`/payments/status/${sessionId}`);
      if (res.data.payment_status === "paid") { setStatus("paid"); checkAuth(); return; }
      if (["expired", "failed"].includes(res.data.status)) { setStatus("failed"); return; }
    } catch { /* retry */ }
    setTimeout(() => poll(sessionId, attempt + 1), 2000);
  }, [checkAuth]);

  useEffect(() => {
    const sessionId = new URLSearchParams(window.location.search).get("session_id");
    if (!sessionId) { setStatus("failed"); return; }
    poll(sessionId, 0);
  }, [poll]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center grid-bg px-6">
      <div className="glass rounded-2xl p-10 max-w-md w-full text-center">
        <div className="mb-6 flex justify-center"><Logo size="lg" /></div>
        {status === "checking" && <><Loader2 className="h-12 w-12 text-indigo-400 animate-spin mx-auto mb-4" /><h1 className="font-heading text-2xl font-bold mb-2">Confirming payment…</h1><p className="text-slate-400">Hang tight, this only takes a moment.</p></>}
        {status === "paid" && <><CheckCircle2 className="h-12 w-12 text-emerald-400 mx-auto mb-4" /><h1 className="font-heading text-2xl font-bold mb-2">You're upgraded! 🎉</h1><p className="text-slate-400 mb-6">Your plan is now active. Enjoy higher AI limits and all agents.</p><button onClick={() => navigate("/dashboard")} className="px-6 py-2.5 rounded-xl bg-indigo-600 hover:bg-indigo-500 font-semibold transition-colors">Go to dashboard</button></>}
        {(status === "failed" || status === "timeout") && <><XCircle className="h-12 w-12 text-rose-400 mx-auto mb-4" /><h1 className="font-heading text-2xl font-bold mb-2">{status === "timeout" ? "Still processing" : "Payment not completed"}</h1><p className="text-slate-400 mb-6">{status === "timeout" ? "Your payment is taking longer than usual. Check billing shortly." : "No charge was made. You can try again anytime."}</p><button onClick={() => navigate("/billing")} className="px-6 py-2.5 rounded-xl bg-white/[0.06] hover:bg-white/[0.1] font-semibold transition-colors">Back to billing</button></>}
      </div>
    </div>
  );
}
